import type { UnverifiedWalletAccount } from '../../unverifiedWalletAccounts';
import type { WalletAccount } from '../../walletAccount';
import { formatWalletAccountId } from '../formatWalletAccountId';

type ConvertUnverifiedWalletAccountToWalletAccountParams = {
  unverifiedWalletAccount: UnverifiedWalletAccount;
};

export const convertUnverifiedWalletAccountToWalletAccount = ({
  unverifiedWalletAccount,
}: ConvertUnverifiedWalletAccountToWalletAccountParams): WalletAccount => ({
  address: unverifiedWalletAccount.address,
  addressesWithTypes: unverifiedWalletAccount.addressesWithTypes,
  chain: unverifiedWalletAccount.chain,
  id: formatWalletAccountId({
    address: unverifiedWalletAccount.address,
    chain: unverifiedWalletAccount.chain,
    walletProviderKey: unverifiedWalletAccount.walletProviderKey,
  }),
  lastSelectedAt: unverifiedWalletAccount.lastSelectedAt,
  verifiedCredentialId: null,
  walletProviderKey: unverifiedWalletAccount.walletProviderKey,
});
